// extracted by mini-css-extract-plugin
module.exports = {"top":"top-module--top--ywedN","topSection":"top-module--topSection--3fwqJ","btn":"top-module--btn--iauo2","title":"top-module--title--1OmEG"};